import { render, staticRenderFns } from "./AddFieldCat.vue?vue&type=template&id=390f5195&"
import script from "./AddFieldCat.vue?vue&type=script&lang=ts&"
export * from "./AddFieldCat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports